module.exports = __webpack_public_path__ + "img/icon-03-dompet-hemat-transparent.d42de206.png";